document.addEventListener('DOMContentLoaded', () => {
  const selectedThickness = document.querySelector('[data-option-slug*="thickness"] input[type="radio"]:checked, [name*="Thickness"]:checked');
  const productTitleWords = Array.from(document.querySelectorAll('.product__title .word'));

  const ashOptions = document.querySelectorAll('[data-option-color*="Ash"], [data-option-value *= "Ash"]');
  // Hide the Ash option until it becomes available

  if (ashOptions) {
    ashOptions.forEach(option => {
      if (option.closest('.color_swatch__wrapper')) {
        option.closest('.color_swatch__wrapper').style.display = 'none';
      } else if (option.closest('.wood')) {
        option.closest('.wood').style.display = 'none';
      }
    });
  }

  // If the product title does not contain the word "Leif", initialize direct event listeners and other functions on page load
  if (!containsWord('Leif', productTitleWords)) {
    initializeDirectEventListeners();
    handleInitialState();
    hideConfigurationOptionLabels();
  }

  let onVariantChangeUnsubscriber = null;

  if (selectedThickness && !containsWord('Leif', productTitleWords)) {
    // Subscribe to the variantChange event using Concept's Pub/Sub system
    onVariantChangeUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (eventData) => {
      // Re-initialize direct event listeners after variant refresh if needed
      initializeDirectEventListeners();
      // Handle the initial state based on current selections
      handleInitialState();
      // Display the weight of the selected variant
      displayVariantWeight(eventData);
    });
  } else {
    // Subscribe to the variantChange event using Concept's Pub/Sub system    
    onVariantChangeUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (eventData) => {
      displayVariantWeight(eventData);
    });
    return;
  }

  // Unsubscribe on page unload
  window.addEventListener('beforeunload', () => {
    if (onVariantChangeUnsubscriber) {
      onVariantChangeUnsubscriber();
      onVariantChangeUnsubscriber = null;
    }
  });
});

function containsWord(targetWord, words) {
  return words.some(word => word.getAttribute('data-word') === targetWord);
}

/**
 * Initializes direct event listeners for Thickness and Depth input fields.
 */
function initializeDirectEventListeners() {
  // Select the thickness radio input wrapper
  const thicknessInputWrapper = document.querySelector('[data-option-slug*="thickness"]');

  if (thicknessInputWrapper) {
    thicknessInputWrapper.addEventListener('change', (e) => {
      const thicknessInput = e.target;
      handleThicknessChange(thicknessInput);
    });
  } else {
    return;
  }

  // Select the depth radio inputs
  // Improved depth listener using event delegation
  const depthInputWrapper = document.querySelector('[data-option-slug="depth"]');
  depthInputWrapper.addEventListener('change', (e) => {
    if (e.target.matches('input[type="radio"]')) {
      handleDepthChange(e);
    }
  });
}

/**
 * Handles changes to the Thickness input fields.
 */
function handleThicknessChange(thicknessInput) {
  const selectedValue = thicknessInput.value;
  const depthOptions = document.querySelectorAll('[data-option-slug="depth"] input[type="radio"]');

  if (selectedValue === '1.25"' && thicknessInput.checked) {
    depthOptions.forEach(option => {
      if (['9"', '10"', '11"', '12"'].includes(option.value)) {
        option.disabled = true;
        option.setAttribute('aria-disabled', 'true');
        if (option.checked) {
          option.checked = false;
        }
      }
    });
  } else if (selectedValue === '1.5"') {
    depthOptions.forEach(option => {
      if (['11"', '12"'].includes(option.value)) {
        option.disabled = true;
        option.setAttribute('aria-disabled', 'true');
        if (option.checked) {
          option.checked = false;
        }
      } else {
        option.disabled = false;
        option.removeAttribute('aria-disabled');
      }
    });
  }
  else {
    depthOptions.forEach(option => {
      option.disabled = false;
      option.removeAttribute('aria-disabled');
    });
  }
}

/**
 * Handles changes to the Depth input fields.
 */
function handleDepthChange(event) {
  const selectedInput = event.target;
  const selectedValue = selectedInput.value;
  const thicknessOptions = document.querySelectorAll('[data-option-slug*="thickness"] input[type="radio"], [name="thickness"]');

  if (['9"', '10"'].includes(selectedValue) && selectedInput.checked) {
    thicknessOptions.forEach(option => {
      if (option.value === '1.25"') {
        option.disabled = true;
        option.setAttribute('aria-disabled', 'true');
        if (option.checked) {
          option.checked = false;
        }
      } else if (option.value === '1.5"' && !option.checked) {
        option.disabled = false;
        option.removeAttribute('aria-disabled');
      }
    });
  } else if (['11"', '12"'].includes(selectedValue) && selectedInput.checked) {
    thicknessOptions.forEach(option => {
      if (option.value === '1.25"' || option.value === '1.5"') {
        option.disabled = true;
        option.setAttribute('aria-disabled', 'true');
        if (option.checked) {
          option.checked = false;
        }
      }
    });
  } else {
    thicknessOptions.forEach(option => {
      option.disabled = false;
      option.removeAttribute('aria-disabled');
    });
  }
}

/**
 * Handles the initial state based on current selections.
 */
function handleInitialState() {
  const selectedThickness = document.querySelector('[data-option-slug*="thickness"] input[type="radio"]:checked, [name*="Thickness"]:checked');
  const selectedDepth = document.querySelector('[data-option-slug="depth"] input[type="radio"]:checked, [name*="Depth"]:checked');

  if (selectedThickness && !['11"', '12"'].includes(selectedDepth.value)) {
    handleThicknessChange(selectedThickness);
  } else if (!selectedThickness) {
    console.log('no thickness element found');
  }

  if (selectedDepth) {
    handleDepthChange({ target: selectedDepth });
  } else {
    console.log('no depth element found');
  }
}

// Display the weight of the selected variant
function displayVariantWeight(eventData) {
  const productId = eventData.data.productId;
  const weightElement = document.querySelector(`#ProductWeight-${productId} span`);
  const weight = convertToPounds(eventData.data.variant.weight);
  weightElement.textContent = weight.toFixed(2) + " lb";
}

function convertToPounds(weight) {
  return weight * 0.00220462;
}

// Hide configuration option labels that are not needed for the product
function hideConfigurationOptionLabels() {
  const configurationOptions = Array.from(document.querySelectorAll('.configuration-items'));

  configurationOptions.forEach(option => {
    if (option.querySelector('[data-option-name*="Location"]') || option.querySelector('[data-option-name*="Radius"]')) {
      option.querySelector('label span').classList.add('sr-only');
    }
  });
}